/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import Loader from './loaderReducer';
import Snackbar from './snackbarReducer';

import history from '../utils/history';
import Root from './rootReducers';
/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer() {
  const combineReducer = combineReducers({
    Loader,
    Snackbar,
    router: connectRouter(history),
    Root,
  });

  return combineReducer;
}
